// 等待状态
const ULRECORDREADY = 0

// 检查权限中
const ULRECORDCHECK = 1
// 录音中
const ULRECORDING = 2
// 录音结束
const ULRECORDEND = 3
// 检查权限拒绝
const ULRECORDDENY = 4

class Record {
  constructor() {
    // 录音的状态
    this.status = ULRECORDREADY
    // 文件路径
    this.filePath = ''
    // 当前声音时长
    this.currentDuration = 0
    // 录音最大时长
    this.durationLimit = 300
    // 定时器
    this._timer = {}

    this.onBeforeStartRecord = function () { }
    this.startRecord = function (success, failure, durationChange) {
      if (this.filePath) {
        this.filePath = ''
        this.status = ULRECORDREADY
      }
      // if (this.status !== ULRECORDREADY) {
      //   // 正在录音中，稍后重试
      //   failure && failure('正在录音请稍后重试')
      //   return
      // }
      // 状态切换为检查中
      this.status = ULRECORDCHECK
      this.onDurationChange = durationChange
      let _this = this
      window.ULplugin.URecorder.onStartRecord = function () {
        _this.onBeforeStartRecord && _this.onBeforeStartRecord()
        _this.status = ULRECORDING
        _this.currentDuration = 0
        _this._timer = setInterval(function () {
          if (_this.currentDuration >= _this.durationLimit) {
            window.ULplugin.URecorder.stopRecord()
            return
          }

          //  不录音时，或者时间超过限制，停止计时，停止录音
          if (_this.status === ULRECORDREADY || _this.status === ULRECORDEND || _this.currentDuration >= _this.durationLimit) {
            _this.stopRecord()
            clearInterval(_this._timer)
            return
          }
          _this.currentDuration++
          _this.onDurationChange && _this.onDurationChange(_this.currentDuration)
        }, 1000)
      }
      window.ULplugin.URecorder.onRecordComplete = function (filePath) {
        _this.status = ULRECORDEND
        _this.filePath = filePath
        if (this._timer) {
          clearInterval(this._timer)
        }
        _this.onRecordCompleteSuccess && _this.onRecordCompleteSuccess(filePath, _this.currentDuration)
        _this.currentDuration = 0
      }
      window.ULplugin.URecorder.checkPermission(() => {
        //  权限允许
        success && success()
        window.ULplugin.URecorder.startRecord()
      }, (msg) => {
        _this.status = ULRECORDDENY
        failure && failure(i18n.t('请打开手机权限'))
        //  权限拒绝
      })
    }

    this.stopRecord = function () {
      // this.status = ULRECORDREADY
      window.ULplugin.URecorder.stopRecord()
    }
    this.clearRecord = function () {
      this.status = ULRECORDREADY
      this.filePath = ''
      this.currentDuration = 0
      this.stopRecord()
    }
    // 录音完成的回调
    this.onRecordCompleteSuccess = function () { }

    this.onDurationChange = function () { }
  }
}

/***
 *录音对象
 */
export function creatRecord() {
  return new Record()
}

// 更新活动列表通知
export function updateActiveList() {
  if (window.broadcaster) {
    window.broadcaster.fireNativeEvent('kLENotificationRefreshActivieList', {}, function () { })
    window.broadcaster.fireNativeEvent('UNotificationNameCourseActivitiesChange', {}, function () { })
    window.broadcaster.fireNativeEvent('unitActivityRefresh', {}, function () { })
  }
}

/*
 * 添加监听从原生发送的通知
 * */
export function addListenNativeEvent() {
  if (window.broadcaster) {
    window.broadcaster.addNativeEvent('kLENotificationRefreshActivieList', {}, function () { })
  }
}



class MobileUploder {
  constructor() {
    this.manger = {}
    // let self = this
    this.uploadFile = function (filePath, progress, success, failure) {
      window.ULplugin.UUploader.uploadFile(filePath, progress, success, failure)
    }
    this.cancelUpload = function (filePath, success) {
      if (!this.manger[filePath]) return
      let model = this.manger[filePath]
      model.cancelSuccess = success
    }
  }
}

export function createUploader() {
  return new MobileUploder()
}

export function download(file) {
  window.FilePugin.download(file.filePath, function (filePath, progress, b, c) {
    // console.log('file process', progress, filePath, file)
    file.progress(progress)
  }, function (filePath, localFilePath) { }, function (filePath, error) { })
};
export function playAudio(audioUrl, complete, durationChange) {
  window.ULplugin.UMedia.playAudio(audioUrl, complete, durationChange)
}

export function stopAudio() {
  window.ULplugin.UMedia.stopAudio()
}

import { formatFileType } from '@/utils/file'

/**
 * getPicture Android 拍照
 * selectFileFromiOS
 * ios 拍照/选择相册/选择相册+视频
 * srcType = args.optInt(2, 1); 1拍照，2图库
 * mediaType = args.optInt(6, 0);  资源类型：0 照片 1视频 2照片+视频
 * saveToPhotoAlbum = args.optBoolean(9, false); 拍照图片是否保存到相册
 * cameraDirection	// 0 后置摄像头 1前置摄像头，默认1
 */
export function getPictureFromMobile(success, fail, options) {
  console.log("options",options);
  if (window.ULplugin && window.ULplugin.Camera) {
    if (options.isAndroid) {
      window.ULplugin.Camera.getPicture(res => {
        const arr = handelResult(res, options)
        success && success(arr)
      }, err => {
        // console.log(err)
        fail && fail('相册权限未打开')
      }, options)
    } else {
      window.ULplugin.Camera.selectMediaFromPhotoAlbum(result => {
        const arr = handelResult(result, options)
        success && success(arr)
      }, err => {
        alert(err)
        fail && fail(err)
      }, options)
    }
  }
  function handelResult(result, options) {
    let arr = []
    if (result && result.length > 0 && options.needFileInfo && options.needFileInfo == 1) {
      var result_copy = JSON.parse(result)
      console.log('result_copy', result_copy)
      result_copy.forEach(item => {
        if (!/^file/.test(item.filepath)) {
          item.filepath = 'file://' + item.filepath
        }
        let fileName = item.filepath.split('/').pop().toString()
        arr.push({
          filePath: item.filepath,
          fileName: fileName,
          fileType: formatFileType(fileName),
          length: item.length
        })
      })
    } else if (result && result.length > 0 && (!options.needFileInfo || options.needFileInfo != 1)) {
      let fileArr = result.split(',')
      fileArr.forEach((file) => {
        if (!/^file/.test(file)) {
          file = 'file://' + file
        }
        let fileName = file.split('/').pop().toString()
        arr.push({
          filePath: file,
          fileName: fileName,
          fileType: formatFileType(fileName)
        })
      })
    }
    return arr
  }
}
export function fileSize(filePath, success, errorFn) {
  if (window.FilePugin) {
    window.FilePugin.fileSize(filePath, success, errorFn)
  }
}

// Android选择文件
export function selectFileFromAndroid(success, fail, options, isPic, exWord) {
  var wordType = '*.doc;*.docx;*.xls;*.xlsx;*.pptx;*.ppt;*.pdf;*.txt;'
  var videoType = '*.mp4;*.avi;*.mov;*.flv;*.rmvb;*.mpg;'
  var audioType = '*.mp3;*.mov;'
  var picType = '.jpg;*.jpeg;*.png;*.gif;'
  var fileType = wordType + videoType + audioType + picType
  if (exWord) {
    fileType = videoType + audioType + picType
  }
  if (isPic) {
    fileType = picType
  }
  var fileSize = 200
  if (window.FilePugin) {
    //fileType, allFileSize, fileMaxCount, fizeSize
    window.FilePugin.selectFile(fileType, 5000, options.maxCount, fileSize)
    window.onSelectedFiles = (fileCount, fileSize, fileArr) => {
      let arr = []
      if (fileArr && fileArr.length > 0) {
        let fileList = JSON.parse(fileArr)
        fileList.forEach((fileModel) => {
          if (fileModel.filepath && !/^file/.test(fileModel.filepath)) {
            let Obj = {}
            Obj.filePath = 'file://' + fileModel.filepath
            Obj.fileType = formatFileType(fileModel.filepath)
            Obj.fileSize = fileModel.length
            Obj.fileName = fileModel.filename
            arr.push(Obj)
          }
        })
      }
      success && success(arr)
    }
  }
}
// iOS选择文件(暂时文件大小，文件数量，文件类型无法限制，只能多选且任选)
export function selectFileFromiOS(success, fail) {
  if (window.ULplugin && window.ULplugin.Camera) {
    window.ULplugin.Camera.selectFileFromiOS(result => {
      let arr = []
      if (result && result.length > 0) {
        let fileArr = JSON.parse(result)
        fileArr.forEach((file) => {
          if (!/^file/.test(file.filepath)) {
            file.filepath = 'file://' + file.filepath
          }
          arr.push({
            filePath: file.filepath,
            fileName: file.filename,
            fileType: formatFileType(file.filename)
          })
        })
      }
      success && success(arr)
    }, err => {
      alert(err)
      fail && fail(err)
    })
  }
}

/* 使用新版上传
  options = {
    module: 'discussion',
    userID: 1111
  }
 */
export function UUploader(file, progress, success, error, cancel, options) {
  if (window.ULplugin && window.ULplugin.UUploader) {
    window.ULplugin.UUploader.uploadV1(file, (file, percent) => {
      progress && progress(file, percent)
    }, (file, filePath) => {
      success && success(file, filePath)
    }, (file, status) => {
      error && error(file, status)
    }, (file, percent) => {
      cancel && cancel(file, percent)
    }, options)
  }
}
export function cancelUpload(file) {
  if (window.ULplugin && window.ULplugin.UUploader) {
    window.ULplugin.UUploader.cancel(file)
  }
}
/*
 * 获取用户信息
 * */
export function getUser(success) {
  if (window.ULplugin && window.ULplugin.User) {
    window.ULplugin.User.getUser(user => {
      console.log(user)
      success && success(user)
    })
  }
}
/*
 * 退出App
 * */
export function exitApp() {
  if (window.ULplugin) {
    window.ULplugin.UApp.finish()
  }
}

/*
 * 下载打开新页面
 * */
export function openWeb(path) {
  if (window.ULplugin) {
    window.ULplugin.UApp.openUrl(path, true)
  }
}
/*
 * 高亮屏幕
 * */
export function setDisplayBrightness(val) {
  if (window.ULplugin) {
    window.ULplugin.UApp.setDisplayBrightness(val)
  }
}
/*
 * 异地登录下线
 * */
export function loggedOnOtherDevices(success, fail) {
  if (window.ULplugin && window.ULplugin.User) {
    window.ULplugin.User.loggedOnOtherDevices(() => {
      success && success()
    }, () => {
      fail && fail()
    })
  }
}

/*
 * 分享
 * */
export function share(shareContent, success, fail) {
  if (window.ULplugin && window.ULplugin.share) {
    window.ULplugin.share.share(shareContent, () => {
      success && success()
    }, () => {
      fail && fail()
    })
  }
}

/*
 * 给原生发送通知
 * */
export function fireNativeEvent(name, str, parentId, callBack) {
  if (window.broadcaster) {
    window.broadcaster.fireNativeEvent(name, {
      'notify': str,
      'parentId': parentId
    }, callBack)
  }
}

